import { render, staticRenderFns } from "./DatasetEmbed.vue?vue&type=template&id=0dd64aac&scoped=true"
import script from "./DatasetEmbed.vue?vue&type=script&lang=js"
export * from "./DatasetEmbed.vue?vue&type=script&lang=js"
import style0 from "./DatasetEmbed.vue?vue&type=style&index=0&id=0dd64aac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd64aac",
  null
  
)

export default component.exports